angular.module('mtic.components.dashboards.teacher_general').directive('teacherStudentsItemZoomRender', 
	function(language) {
    return {
        templateUrl: 'template.html',
        scope: {
            resourceSummary: '=',
            resource: '='
        },
        link: function(scope){
        	scope.language = language;
        	scope.checkpointDatas = [];
        	scope.checkpoints = [
         //    {
        	// 	componentId: 'mtic_g78_m1_rule_three/framePlayer',
        	// 	langId: 'inbook_framePlayer'//ToDO, change to real langId
        	// }
            ];
        	if(scope.resource.config.checkpoints){
        		scope.checkpoints = scope.resource.config.checkpoints
        	}else{
                scope.disabled = true
            }
        	var instances = JSON.parse(scope.resourceSummary.component_instances);
        	var state = JSON.parse(scope.resourceSummary.app_state);
        	var logData = scope.resourceSummary.log_data;
        	scope.checkpointDatas = scope.checkpoints.filter(function(config) {
        		return state[config.componentId] && instances[config.componentId]
        	}).map(function(config){
        		return {
        			componentType: instances[config.componentId],
					componentId: config.componentId,
					state: state[config.componentId],
					logdata: logData.filter(function(componentLog){
						return componentLog.componentId === config.componentId;
					})
        		}
        	})

        }
    }
})